import type { ReactNode } from "react";
import "./FlatSelectMulti.scss";
import type { Item } from "@/shared/components/generic/items.ts";
import classNames from "classnames";
import FlatSelectMultiItem from "@/pages/human-resources/time-management/schedules/site-schedule/toolbar/display-options/menu/flat-select-multi/FlatSelectMultiItem.tsx";
import ThreeStatesCheckbox from "@/shared/components/generic/checkbox/ThreeStatesCheckbox.tsx";
import { computeNoneSomeAll } from "@/shared/components/generic/checkbox/model/ThreeStateCheckboxHelper.ts";
import { Size } from "@/shared/components/generic/UiEnums.ts";
import { useTranslation } from "react-i18next";

interface Properties<T> {
  title: string;
  items: Item<T>[];
  isSelectedItem: (item: Item<T>) => boolean;
  onSelectItem: (item: Item<T>) => void;
  showSelectAll: boolean;
  onSelectAll?: () => void;
  onSelectNone?: () => void;
  folded: boolean;
  onFoldedChanged: (folded: boolean) => void;
}

export default function FlatSelectMulti<T>(props: Properties<T>): ReactNode {
  const { t } = useTranslation("common");
  return (
    <div className={classNames("flat-select-multi", props.folded && "folded")}>
      <div
        className="flat-select-multi-title"
        onClick={() => {
          props.onFoldedChanged(!props.folded);
        }}
      >
        <div className={"label"}>{props.title}</div>
        <div className={"fold-icon"} />
      </div>
      {!props.folded && (
        <div className="flat-select-multi-items">
          {props.showSelectAll && (
            <ThreeStatesCheckbox
              state={computeNoneSomeAll(props.items, props.isSelectedItem)}
              onChange={(na) => {
                switch (na) {
                  case "all":
                    props.onSelectAll?.();
                    break;
                  case "none":
                    props.onSelectNone?.();
                    break;
                }
              }}
              label={t("common:all")}
              size={Size.XSMALL}
            />
          )}

          {props.items.map((item) => (
            <FlatSelectMultiItem
              key={item.key}
              label={item.label}
              selected={props.isSelectedItem(item)}
              onSelect={() => {
                props.onSelectItem(item);
              }}
            />
          ))}
        </div>
      )}
    </div>
  );
}
